'use strict';

jQuery($ => {
    $('.gecko-builder-faq-section__section').each((i, ui) => {
        const section = $(ui);
        const title = section.find('.gecko-builder-faq-section__section-title');
        const content = section.find('.gecko-builder-faq-section__section-content');

        title.on('click', (e) => {
            e.preventDefault();

            if (section.attr('data-status') == 'active') {
                section.removeAttr('data-status');
                content.stop().slideUp(100);
            } else {
                section.attr('data-status', 'active');
                content.stop().slideDown(100);
            }
        });
    });
});
